import script from "./TemplatePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&setup=true&lang=js"

import "./TemplatePreview.vue?vue&type=style&index=0&id=22c828c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c828c4"]])

export default __exports__